<template>
    <div>
        <el-breadcrumb separator=">" class="bread">
            <el-breadcrumb-item :to="{ name: 'advertiseManager' }">广告管理</el-breadcrumb-item>
            <el-breadcrumb-item>发布广告</el-breadcrumb-item>
        </el-breadcrumb>

        <div >
            <el-form  :model="materiaForm" :rules="materiarules" ref="materiaForm" label-width="100px" class="demo-ruleForm"  :label-position="labelposition" >

                <el-form-item label="广告名称" prop="advName">
                    <el-input v-model="materiaForm.advName" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item label="开始时间" prop="startTime">
                    <el-date-picker
                            v-model="materiaForm.startTime"
                            type="datetime"

                            placeholder="选择日期"
                            @change="getStartDate"
                    >
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker
                            v-model="materiaForm.endTime"
                            type="datetime"

                            placeholder="选择日期"
                            @change="getEndDate"
                    >
                    </el-date-picker>
                </el-form-item>

            </el-form>

        </div>


        <el-row class="check">
            <el-col :span="26">
                <el-tabs v-model="activeName2" type="card" @tab-click="tabsClick" v-loading="loading2"
                         element-loading-text="正在发布，请耐心等待。">

                    <!--<el-tab-pane name="third">-->
                        <!--<span slot="label"><i class="fa fa-tags" style="vertical-align:middle;"></i>分组选择</span>-->
                        <!--<el-transfer-->
                                <!--class="transfer-size"-->
                                <!--v-model="grvalue"-->
                                <!--:props="{-->
                                  <!--label: 'branchName',-->
                                  <!--key: 'branchId',-->
                                <!--}"-->
                                <!--filterable-->
                                <!--:titles="['可选择', '已选择']"-->
                                <!--:footer-format="{-->
                                  <!--noChecked: '${total}',-->
                                  <!--hasChecked: '${checked}/${total}'-->
                                <!--}"-->
                                <!--@change="handleChange1"-->
                                <!--:data="branchList"-->
                        <!--&gt;-->
                            <!--<el-pagination slot="left-footer"-->
                                           <!--small-->
                                           <!--@current-change="handleCurrentChange"-->
                                           <!--@size-chahange="handleSizeChange"-->
                                           <!--:current-page="currentpage"-->
                                           <!--:page-size="pagesize"-->
                                           <!--:total="pagesCount"-->
                                           <!--layout="prev, pager, next"-->
                                           <!--class="pagina"-->
                            <!--&gt;-->
                            <!--</el-pagination>-->
                        <!--</el-transfer>-->
                    <!--</el-tab-pane>-->

                    <el-tab-pane name="third">
                        <span slot="label"><i class="el-icon-search"></i>机器选择</span>
                        <el-transfer
                                class="transfer-size"
                                v-model="resvalue"
                                :props="{
                                  key: 'fxDeviceId',
                                  label: 'deviceName'
                                }"
                                filterable
                                :titles="['可选择', '已选择']"
                                :footer-format="{
                                  noChecked: '${total}',
                                  hasChecked: '${checked}/${total}'
                                }"
                                :data="kioskData">
                            <el-pagination slot="left-footer"
                                           small
                                           @current-change="handleCurrentChange"
                                           :current-page="currentpage"
                                           :page-size="pagesize"
                                           :total="pagesCount"
                                           layout="prev, pager, next"
                                           class="pagina"
                            >
                            </el-pagination>
                        </el-transfer>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>



        <el-row class="controll">
            <el-col :span="24">
                <div class="grid-content">
                    <el-button type="primary" @click="pushResource('materiaForm')" >发布</el-button>
                    <el-button   @click="back()">返回</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import moment  from 'moment'
    export  default{
        data(){
            return{
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                flag: false,
                pagesize: 200,//行数
                activeNum: 0, //默认起始行数
                endNum: 15,//默认结束行数
                kioskData: [], // 分页组件传回的分页后数据
                getkioskData: "", // 分页组件传回的分页后数据
                storeData: [], // 分页组件传回的分页后数据
                branchList: [], // 分页组件传回的分页后数据
                branchId:'',
                branchIdList:[],
                resvalue: [],//单个选择结果集
                resname: [],//单个选择结果集
                grvalue: [],//单个选择结果集
                stovalue: [],//单个选择结果集
                taskTime:'',
                activeName2: 'third',
                tabnum:'third',
                advId:"",
                loading:false,
                loading2:false,
                labelposition:"left",
                materiaForm:{
                    advName:'',
                    startTime:'',
                    endTime:'',
                },
                materiarules: {

                },
                fusionToken:'',
            }
        },
        created(){
            console.log(this.kioskData)
            this.advId=this.$route.query.advId;
            this.materiaForm.advName=this.$route.query.acvName;
            this.getData();
            this.toUpdate();
            this.getBranch();
        },methods:{
            getBranch(){
                this.$http.get(this.deviceHost+"/vueFeign/findBranchs?tenantId="+this.getcookie('storeId')+"&Token="+this.token)
                    .then(response => {
                        if (response.body.Code === '200') {
                            this.fusionToken = response.body.Data.branchs[0].fusionToken;
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            handleChange1() {
                for(var i = 0;i<this.branchList.length;i++){
                    console.log(this.branchList[i].branchId);
                    this.branchId = this.branchList[i].branchId;
                    this.kioskData = [];
                    this.getKisok();
                }
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.activeNum=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.getData();
            },
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.activeNum=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.getData();
                //数目变更
            },
            getData(){
                this.getBranchList();
//                this.getKisok();
            },
            getBranchList(){
                this.$http.get(this.deviceHost+"/vueFeign/findBranchs?tenantId="+this.getcookie('storeId')+"&Token="+this.token)
                    .then(response => {
                        if (response.body.Code === '200') {
                            this.branchList = response.body.Data.branchs;
//                            this.branchId = response.body.Data.branchs[0].branchId;
//                            this.getKisok();
                            this.handleChange1();
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            getKisok(){
                this.$http.get(this.deviceHost+"/vueFeign/findDeviceList?tenantId="+this.getcookie('storeId')+"&branchId="+this.branchId+"&Token="+this.token)
                    .then(response => {
                        if (response.body.Code === '200') {
                            if(response.body.Data != null){
                                this.kioskData = this.kioskData.concat(response.body.Data);
                                console.log(this.kioskData)
                            }
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            toUpdate(){
            },
            pushResource(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var deviceId = "";
                        if(this.materiaForm.endTime == ''){
                            var end = new Date().setYear(9999);
                            var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                            this.materiaForm.endTime = moment(end).format(formatString);
                        }
                        if(this.materiaForm.startTime == ''){
                            var d = new Date();
                            var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                            this.materiaForm.startTime = moment(d).format(formatString);
                        }
                        if(this.materiaForm.endTime < this.materiaForm.startTime){
                            this.$message({showClose: true, message: '结束时间不能小于开始时间', type: 'error'});
                            return false;
                        }

                        if (this.resvalue.length > 0 || this.grvalue.length > 0) {
                            if (this.resvalue.length > 0) {
                                this.resvalue.forEach(function (item, i) {
                                    deviceId += item + ",";
                                })
                            }else {
                                this.$message({showClose: true,message: '请选择机器',type: 'warning'});
                                return false;
                            }
                            if(this.getkioskData != ''){
                                deviceId += this.getkioskData;
                            }
                            var params = {advertiseId:this.advId,deviceId:deviceId,Token: this.fusionToken,
                                startTime:this.materiaForm.startTime,endTime:this.materiaForm.endTime,tenantId:this.getcookie('storeId')};
                            this.$http.post(this.deviceHost + "/vueFeign/pushAdvertise", params)
                                .then(response => {
                                    var data=response.body;
                                    if(data.Code=="200") {
                                        this.$message({showClose: true, message: '发布成功', type: 'success'});
                                        this.$router.push({path: "advertiseManager"})
                                    }else if(data.Code=="51104"){
                                        this.$message({showClose: true, message: data.msg, type: 'success'});
                                    }else{
                                        this.$message({showClose: true,message: '参数错误',type: 'error'});
                                    }
                                },()=>{
                                    this.$message({showClose: true,message: '网络异常',type: 'error'});
                                })
                        } else {
                            this.$message({
                                showClose: true, message: '请选择要发布的机器',
                                type: 'warning'});
                        }
                    }
                })
            },
            getStartDate(vue){
                var d = new Date(vue);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                this.materiaForm.startTime=moment(d).format(formatString);
            },
            getEndDate(vue){
                var d = new Date(vue);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                this.materiaForm.endTime=moment(d).format(formatString);
            },
            tabsClick(tab, event){
                this.tabnum = tab.name;
            },
            back(){
                this.$router.push({path:"advertiseManager"})
            }
        },
        watch: {
            // 如果路由有变化，会再次执行该方法
            '$route': 'toUpdate'
        }
    }
</script>
<style>
    .transfer-size .el-transfer-panel{
        width: 400px;
        height: 500px
    }
    .transfer-size .el-checkbox-group{
        height: 380px;
    }
    .transfer-footer {
        margin-left: 20px;
        padding: 6px 5px;
    }
    .pagina{
        margin-top: 1.5px;
        margin-right: 140px;
        width: 40%;
        float: right;
    }
    .controll{
        margin-top: 15px;
    }
    .el-transfer-panel__body .el-input__inner{
        height:30px;
    }
</style>



// WEBPACK FOOTER //
// AdPush.vue?4eae027d